var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "draggable",
        {
          ref: "tasks",
          staticClass: "tasks-group",
          attrs: {
            delay: "30",
            "delay-on-touch-only": "true",
            "touch-start-threshold": "5",
            handle: ".rm-task-handle",
            list: _vm.tasks,
            disabled: _vm.readonly,
            "ghost-class": "ghost"
          },
          on: {
            start: function($event) {
              _vm.dragging = true
            },
            end: function($event) {
              _vm.dragging = false
            }
          }
        },
        _vm._l(_vm.tasks, function(task, idx) {
          return _c("task", {
            key: task.id,
            attrs: {
              task: task,
              fieldPermissions: _vm.permissions,
              i18n: _vm.i18n,
              readonly: _vm.readonly,
              debug: _vm.debug,
              usermBaseUrl: _vm.usermBaseUrl
            },
            on: {
              editTask: function($event) {
                return _vm.onEdit(idx)
              },
              deleteTask: function($event) {
                return _vm.remove(idx)
              }
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      !_vm.readonly && _vm.permissions.CREATE
        ? _c("i", {
            staticClass: "clickable icon-plus-sign text-green",
            on: { click: _vm.add }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c(
            "div",
            _vm._l(_vm.tasks, function(dTask) {
              return _c("div", { key: dTask.id }, [_vm._v(_vm._s(dTask))])
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }